
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollGrid extends Serenity.EntityGrid<PayrollRow, any> {
        protected getColumnsKey() { return 'HR.Payroll'; }
        protected getDialogType() { return PayrollDialog; }
        protected getIdProperty() { return PayrollRow.idProperty; }
        protected getInsertPermission() { return PayrollRow.insertPermission; }
        protected getLocalTextPrefix() { return PayrollRow.localTextPrefix; }
        protected getService() { return PayrollService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(99);
            var userDefinition = Q.Authorization.userDefinition;
            var autoposting = OMS.VoucherMasterRow.getLookup().itemById[99].AutoPosting;
            this.editItem(<PayrollRow>{
                VoucherNo: voucherNo, 
                CompanyId: userDefinition.CompanyId,
                FinancialYearId: userDefinition.FinancialYearId,
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                VoucherTypeId: 99,
                TransDate: now.toDateString(),
            });
        }
    }
}